import mime from 'mime'

export const AVATAR_MAX_DIMENSION = 500

const ENCODABLE_TYPES = ['image/jpeg', 'image/png', 'image/webp']

const FALLBACK_TYPE = 'image/png'

export function renameFileToMimeType(fileName: string, mimeType: string): string {
  const extension = mime.getExtension(mimeType)
  if (!extension) {
    return fileName
  }
  const dotIndex = fileName.lastIndexOf('.')
  const baseName = dotIndex === -1 ? fileName : fileName.slice(0, dotIndex)
  return `${baseName}.${extension}`
}

export function getOutputSize(width: number, height: number, maxDimension: number, minHeight = 0): { width: number; height: number } {
  const capRatio = Math.min(1, maxDimension / Math.max(width, height))
  const ratio = height * capRatio < minHeight ? Math.min(1, minHeight / height) : capRatio
  return { width: Math.round(width * ratio), height: Math.round(height * ratio) }
}

export function getOutputType(sourceType: string | null): string {
  return sourceType !== null && ENCODABLE_TYPES.includes(sourceType) ? sourceType : FALLBACK_TYPE
}
